// MessageModal.jsx
import React, { useState } from 'react';
import styles from './MessageModal.module.css';
import { useSendOrderMesgMutation, useSendMesgMutation } from '../../../../store/api/tgBot.api'

export const MessageModal = ({ isOpen, onClose, orderId, userId, schema }) => {
	const [message, setMessage] = useState('');
	const [sendBotOrderMessage] = useSendOrderMesgMutation();
	const [sendBotMessage] = useSendMesgMutation();
	console.log(userId)


	const handleSend = async () => {
		try{
			if(orderId){
				await sendBotOrderMessage({ userId, text: message, orderId, schema });
			} else{
				await sendBotMessage({ userId, text: message })
			}
		} catch (e) {
			alert('Ошибка при отправке сообщения');
		}

		alert('Сообщение отправлено');
		onClose();
	};

	if (!isOpen) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<h3>{orderId ? `Отправить сообщение по заказу #${orderId}` : `Отправить сообщение пользователю ${userId}`}</h3>
				<textarea
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					className={styles.textarea}
					placeholder="Введите сообщение"
				/>
				<div className={styles.actions}>
					<button onClick={handleSend}>Отправить</button>
					<button onClick={onClose}>Отмена</button>
				</div>
			</div>
		</div>
	);
};
